import { Component, OnInit } from '@angular/core';
import {SettingsComponent} from '../settings.component';
import {AppComponent} from '../../app.component';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.scss']
})
export class AccountsComponent implements OnInit {

  constructor(public settingComp: SettingsComponent, private appComp: AppComponent) { }

  ngOnInit() {
    this.appComp.currentPageTitle = 'Manage Accounts';
    this.appComp.ribbon = 'Account Management';
    if (!this.settingComp.item) {
      this.settingComp.setcolumnvalues();
    }

  }

}
